<gridster [options]="options">
    <gridster-item [item]="item" *ngFor="let item of dashboard;let i = index">
      <pms-widget [index]="i"></pms-widget>
    </gridster-item>
  </gridster>